window.addEventListener('DOMContentLoaded', () => {
    const sliderWrapper = document.querySelector('.slider-wrapper');
    if (sliderWrapper) {
        const slides = document.querySelectorAll('.single-slide');
        const numberOfSlides = slides.length;
        for (let i = 0; i < numberOfSlides; i++) {
            let clone = slides[i].cloneNode(true);
            sliderWrapper.appendChild(clone);
        }
    }
});

// Cards slider (mobile touch drag)
const slider = document.querySelector('.slider');

if (slider) {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('touchstart', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.touches[0].pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('touchend', () => {
        isDown = false;
        slider.classList.remove('active');
        snapToSlide();
    });

    slider.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        e.preventDefault();

        const x = e.touches[0].pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;

        slider.scrollLeft = scrollLeft - walk;
    });

    function snapToSlide() {
        const sliderWidth = slider.offsetWidth;
        const halfway = sliderWidth / 2;
        const currentScroll = slider.scrollLeft;

        if (currentScroll < halfway) {
            slider.scrollTo({
                left: sliderWidth,
                behavior: 'smooth'
            });
        } else {
            slider.scrollTo({
                left: 0,
                behavior: 'smooth'
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const animatedElements = document.querySelectorAll('.animated-box-r, .animated-box-l, .animated-date');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.5
    });

    animatedElements.forEach(element => {
        observer.observe(element);
    });
});

// AJAX Submit
jQuery(document).ready(function($) {
    const popup = window.aviationLandingPopup || {};

    $('#landing_page_subscription').on('submit', function(event) {
        event.preventDefault();

        var formData = {
            'action': 'subscribe_user',
            'data': {
                'names': $('input[name="names"]').val(),
                'subscribe_email': $('input[name="subscribe_email"]').val(),
                'subscribeWebsite': $('input[name="subscribeWebsite"]').val(),
                'subscribeLanguage': $('input[name="language"]').val()
            }
        };

        $('#responseBox').html('');

        $.ajax({
            type: 'POST',
            url: popup.ajaxUrl,
            data: formData,
            dataType: 'json',
            success: function(response) {
                if (response.success) {
                    $('body').append(
                        '<div class="popup-container">' +
                            '<div class="popup-wrapper">' +
                                '<div class="close-button">&times;</div>' +
                                '<div class="popup-heading"><h2>' + (popup.heading || '') + '</h2></div>' +
                                '<div class="popup-body"><p style="line-height: 1.5;">' + (popup.body || '') + '</p></div>' +
                                '<div class="popup-button"><a href="' + (popup.buttonLink || '#') + '" target="_blank">' + (popup.buttonText || '') + '</a></div>' +
                            '</div>' +
                        '</div>'
                    );

                    $('.popup-container').fadeIn();
                } else {
                    $('#responseBox').html('<p style="color:red;">' + response.data + '</p>');
                }
            },
            error: function(xhr, status, error) {
                $('#responseBox').html('<p style="color:red;">There was a problem with the request. Please try again later.</p>');
            }
        });
    });

    // Close the popup when clicking the close button
    $(document).on('click', '.close-button', function() {
        $('.popup-container').fadeOut(function() {
            $(this).remove();
        });
    });

    // Close the popup when clicking outside the popup wrapper
    $(document).on('click', '.popup-container', function(e) {
        if ($(e.target).closest('.popup-wrapper').length === 0) {
            $('.popup-container').fadeOut(function() {
                $(this).remove();
            });
        }
    });
});

// Scroll to the top of the page smoothly, then focus the name input
const regScrollBtn = document.querySelector('.reg-scroll');
if (regScrollBtn) {
    regScrollBtn.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        setTimeout(function() {
            const nameInput = document.querySelector('.name-input');
            if (nameInput) {
                nameInput.focus();
            }
        }, 500);
    });
}
